module.exports = __webpack_public_path__ + "img/fb-carrousel.c4fc560c.svg";